import { FontFamily } from "common-assets/assets/fonts/fonts";
import { isMobileApp } from "../mobile/detectMobile";

export enum FontSizeTypeValues {
  xs = 'xs',
  s = 's',
  base = 'base',
  m = 'm',
  l = 'l',
  xl = 'xl',
  xxl = 'xxl',
  xxxl = 'xxxl',
  xxxlLg = 'xxxlLg',
  xxxxl = 'xxxxl',
  subHeadline2 = 'subHeadline2',
}

export const fontSize = {
  xs: 12, // body 3
  s: 14, // body 2
  base: 16, // body 1
  /** @deprecated */
  m: 18,
  l: 19, // H4
  xl: 24, // H3
  xxl: 28, // H2
  xxxlLg: 32, // H1 (lg)
  xxxl: 36, // H1 (xl)
  xxxxl: 48, // special header
  subHeadline2: 24, // sub headline 2
} as const;

export const lineHeightToFontSize = {
  xxxxl: 60,
  xxxl: 45,
  xxxlLg: 40,
  xxl: 35,
  xl: 30,
  subHeadline2: 32,
  l: 28,
  base: 24,
  s: 20,
  xs: 18
} as const;

// @ts-ignore
export const getMobileAppParams = () => isMobileApp() ? window.Flamingo2AppOptions as FlamingoAppParams : undefined;

export const space = {
  appPadding: 16,
  navCollapseWidth: 56,
  navWidth: 244,
  maxWidth: 1620,
  headerHeight: 97,
  basicDataMaxWidth: 1032,
  headerMobileHeight: 64,
  mobileNavHeight: () => 64 + (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileBottomPadding: () => (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileTopPadding: () => (getMobileAppParams()?.safeViewTop ?? 0)
};

// 1.3 font family
export const ingMeWebRegular =  `${FontFamily}, Helvetica, Arial, sans-serif`;
export const ingMeWebBold =  `${FontFamily}, Helvetica, Arial, sans-serif` ;

export enum StylesIndexInjections {
  UI_ATOMS = 1,
  UI_MOLECULES = 2,
  OTHER = 3,
}